import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedDate } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import colors from '@app/constants/colors';
import { Package, PackageContainer, Modal } from '@app/components';
import { subscriptionStatus } from '@app/constants/subscribe';
import SubscriptionHistory from './SubscriptionHistory';

class PackageInformation extends React.Component {
  state = {
    isSubscriptionsHistoryVisible: false,
  };

  render() {
    const { option } = this.props;
    const { isSubscriptionsHistoryVisible } = this.state;
    const { validTo, validFrom, statusId } = option;
    const renewalState = statusId === subscriptionStatus.ACTIVE
      ? 'subscription.enabled' : 'subscription.disabled';
    const packageState = (() => {
      switch (statusId) {
        case subscriptionStatus.ORDERED:
          return 'subscription.ordered';
        case subscriptionStatus.ACTIVE:
        case subscriptionStatus.TERMINATED:
          return 'subscription.active';
        default:
          return 'subscription.canceled';
      }
    })();

    return (
      <React.Fragment>
        <PackageContainer>
          <Package
            key={option.optionId}
            option={option}
            disabled={!!option}
            hasMargin={false}
            onOptionSelect={() => {}}
          />
          <StatusContainer>
            <StatusRow>
              <Name>
                <FormattedMessage id="subscription.status" />
              </Name>
              <Status>
                <FormattedMessage id={packageState} />
              </Status>
            </StatusRow>
            <StatusRow>
              <Name>
                <FormattedMessage id="subscription.autoRenewal" />
              </Name>
              <Status>
                <FormattedMessage id={renewalState} />
              </Status>
            </StatusRow>
            <StatusRow>
              <Name>
                <FormattedMessage id="subscription.startDate" />
              </Name>
              <Status>
                {
                  validFrom
                    ? (
                      <FormattedDate
                        value={new Date(validFrom * 1000)}
                        month="long"
                        year="numeric"
                        day="numeric"
                      />
                    ) : ('-')
                }
              </Status>
            </StatusRow>
            <StatusRow>
              <Name>
                <FormattedMessage id="subscription.endDate" />
              </Name>
              <Status>
                {
                  (validFrom && validTo)
                    ? (
                      <FormattedDate
                        value={new Date(validTo * 1000)}
                        month="long"
                        year="numeric"
                        day="numeric"
                      />
                    )
                    : '-'
                }
              </Status>
            </StatusRow>
            <LinkRow>
              <ModalLink onClick={() => this.setState({ isSubscriptionsHistoryVisible: true })}>
                <FormattedMessage id="subscription.history.title" />
              </ModalLink>
            </LinkRow>
          </StatusContainer>
        </PackageContainer>
        <Modal
          show={isSubscriptionsHistoryVisible}
          onHide={() => this.setState({ isSubscriptionsHistoryVisible: false })}
        >
          <SubscriptionHistory />
        </Modal>
      </React.Fragment>
    );
  }
}

PackageInformation.propTypes = {
  option: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default connect(null, {})(PackageInformation);

const StatusContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-left: 10px;

  @media (max-width: 728px) {
    margin-left: 0;
  }   
`;

const StatusRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  transition: all 0.5s ease;
  animation: animateShowDown 0.5s ease;  
`;

const LinkRow = styled(StatusRow)`
  justify-content: flex-end;
  align-items: right;
  text-align: right;
`;

const Name = styled.p`
  flex: 0.6;
  font-weight: bold;
  text-align: left;
  margin: 10px auto;
  padding: 10px;
  text-transform: capitalize;
`;

const Status = styled(Name)`
  flex: 1;
  font-weight: normal;
  text-align: center;
  border-radius: 5px;
  border: 1px solid ${colors.ALICE_BLUE};
`;

const ModalLink = styled.span`
  margin: 30px 0 0;
  font-size: 20px;
  color: ${colors.SUPERNOVA};
  text-decoration: underline;
  cursor: pointer;
`;
